import React from 'react';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import { Button, Input, Dropdown } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class Addpricemenu extends React.Component {

  state = {
    DiscountLevel: [], item: { status: 1 }
  }


  getDiscountLevel = () => {
    let context = this;
    context.setState({ load: false, message: 'Getting Discount Level!!!' })
    $.ajax({
      type: 'POST', url: Server() + 'WebMaster/DiscountMenu/GetDiscountLevelName.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.status == '1' || c.status == 1) {
              c.status = 1;
            }
            else {
              c.status = 0;
            }
          })
          context.setState({ DiscountLevel: data, load: false, DiscountMasterDialog: true });
        } catch (e) {
          context.setState({ load: false, DiscountLevel: [] });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  submit = () => {
    let context = this;
    let { item } = this.state;
    context.setState({ load: false, message: 'Getting Discount Level!!!' })
    $.ajax({
      type: 'POST', data: item, url: Server() + 'WebMaster/DiscountMenu/AddEditDiscountLevelName.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ DiscountAddDialog: false, item: { status: 1 } });
          context.getDiscountLevel();
        }
        else {
          alert('Error')
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  selectStatus = (f, { value }) => { 
    this.setState({
        item: {
          ...this.state.item,
          "status": value,
        },
    });
  }

  handleChange = name => event => {
    this.setState({
        item: {
        ...this.state.item,
        [name]: event.target.value,
        },
    });
};

  render() {
    let { DiscountMasterDialog, DiscountAddDialog, DiscountLevel, item } = this.state;
    let i = 1;
    return (
      <div>
        <Button onClick={this.getDiscountLevel}>Add Discount Level Name</Button>
        <Dialog onClose={ () => this.setState({ DiscountMasterDialog: false }) } fullWidth={true} maxWidth={'md'} open={DiscountMasterDialog} aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Discount Level"}</DialogTitle>
            <DialogContent>
              <table width='100%' id='emp_table'>
                <tr id='tableheader'>
                  <th id='tablecolumn'><b>S.No</b></th>
                  <th id='tablecolumn'><b>Discount Level Name</b></th>
                  <th id='tablecolumn'><b>Status</b></th>
                  <th id='tablecolumn'><b>Action</b></th>
                </tr>
                {
                  DiscountLevel.map((c) => {
                    return(
                      <tr>
                        <td>{i++}</td>
                        <td>{c.name}</td>
                        <td>{c.status == '1' || c.status == 1 ? "Active" : "Inactive"}</td>
                        <td onClick={ () => this.setState({ DiscountAddDialog: true, item: c }) }>Edit</td>
                      </tr>
                    )
                  })
                }
              </table>
              <Dialog onClose={ () => this.setState({ DiscountAddDialog: false }) } fullWidth={true} maxWidth={'xs'} open={DiscountAddDialog} aria-labelledby="responsive-dialog-title">
                  <DialogTitle id="responsive-dialog-title" id="widthdialog">{"ADD / EDIT Discount Level"}</DialogTitle>
                  <DialogContent>
                    <b>Discount Level Name</b><br/>
                    <Input onChange={this.handleChange('name')} placeholder='Name' fluid value={item.name} /><br/>
                    <b>Status</b><br/>
                    <Dropdown placeholder='Status' style={{ borderColor: '#5A9CBB', width: '300px' }}
                      onChange={this.selectStatus} selection
                      options={[{key: 'Active', text: 'Active', value: 1}, {key: 'Inactive', text: 'Inactive', value: 0}]} 
                      value={item.status} />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={ () => this.setState({ DiscountAddDialog: false }) }>Close</Button>
                    <Button onClick={this.submit}>Submit</Button>
                  </DialogActions>
              </Dialog>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => this.setState({ DiscountMasterDialog: false }) }>Close</Button>
              <Button onClick={ () => this.setState({ DiscountAddDialog: true })}>Add Discount Level Name</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Addpricemenu;
